import { Store } from "lucide-react";

/**
 * Public storefront when the merchant catalog is not live (expired / suspended subscription).
 * No login buttons, products, or technical details.
 */
export default function CatalogStoreUnavailable({ language = "ar" }) {
  const isAr = language !== "en";
  const message = isAr
    ? "هذا المتجر غير متاح حالياً"
    : "This store is currently unavailable";

  return (
    <div
      className="catalog-store-unavailable"
      role="main"
      aria-live="polite"
      style={{ direction: isAr ? "rtl" : "ltr" }}
    >
      <div className="catalog-store-unavailable__card">
        <div className="catalog-store-unavailable__icon" aria-hidden>
          <Store size={40} strokeWidth={2} />
        </div>
        <p className="catalog-store-unavailable__message">{message}</p>
      </div>
    </div>
  );
}
